enum CharmSize {
    size14 = 0,
    size16 = 1,
}

export default CharmSize;
